<template>
  <div>
    <search-sale-agent-monthly-performance
      statistic-type="stored"
      @submit="submitSearch"
    />

    <a-table
      :scroll="{ x: 'max-content' }"
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      :row-class-name="rowClassName"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import SearchSaleAgentMonthlyPerformance from '@/views/sale_monthly_performances/info/Search'
import { findSaleAgentMonthlyStorePerformances } from '@/api/sale_monthly_performance'
import { formatCurrency } from '@/utils/filter'

export default {
  name: 'SaleMonthlyPerformanceInfoStoredList',
  components: {
    Pagination,
    SearchSaleAgentMonthlyPerformance
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '客户名称',
          dataIndex: 'agent_name'
        },
        {
          title: '账单类型',
          dataIndex: 'bill_type'
        },
        {
          title: '项目批次',
          dataIndex: 'agent_bill_no'
        },
        {
          title: '账单金额(元)',
          customRender: formatCurrency,
          dataIndex: 'amount'
        },
        {
          title: '底价结算金额(元)',
          customRender: formatCurrency,
          dataIndex: 'floor_amount'
        },
        {
          title: '账单-底价差额(元)',
          customRender: formatCurrency,
          dataIndex: 'sale_profit'
        },
        {
          title: '数量',
          dataIndex: 'cards_count'
        },
        {
          title: '账单时间',
          dataIndex: 'agent_bill_time'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findSaleAgentMonthlyStorePerformances(this.id, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    },

    rowClassName(record) {
      if (record.sale_profit != null && Number(record.sale_profit) < 0) {
        return 'sale-profit-negative-row'
      }
      return ''
    }
  }
}
</script>

<style>
.sale-profit-negative-row td {
  color: #f5222d !important;
}
</style>
